import { useCallback } from "react";
import { FirestoreProductSubject } from "reedy-data/models";
import { SelectableListItem } from "~/components/list/selectable-list-item";
import { useSubjects } from "~/hooks/use-subjects";

interface SubjectItemProps {
  subject: FirestoreProductSubject;
  isSelected: boolean;
  testId: string;
  className?: string;
}

export const SubjectItem = ({
  subject,
  isSelected,
  testId,
  className,
}: SubjectItemProps) => {
  const { handleToggleSubject } = useSubjects();

  const handleClicked = useCallback(() => {
    handleToggleSubject(subject);
  }, [handleToggleSubject, subject]);

  if (!subject.subjectCode) {
    return null;
  }

  return (
    <SelectableListItem
      id={subject.subjectCode}
      text={subject.subjectCode}
      subtext={subject.subjectHeadingText ?? ""}
      isSelected={isSelected}
      testId={testId}
      onSelect={handleClicked}
      infoText={subject.reasoning ?? undefined}
      className={className}
    />
  );
};
